var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowRoundedRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 11,
    height: 18,
    fill: "none",
    viewBox: "0 0 11 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#00A3FA",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.029,
    d: "m1.522 1.793 8.013 7.44-8.013 7.442"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRoundedRight);
export default __webpack_public_path__ + "static/media/arrow-rounded-right.30949c375aeb30d4351f6337a24e61fa.svg";
export { ForwardRef as ReactComponent };